import styled from "@emotion/styled";

export type ContentProps = {
  children: React.ReactNode;
  className?: string | undefined;
};

const ContentStyles = styled.div`
  width: 100%;
  max-width: 1240px;
  margin: 24px auto;
`;

const Content = ({ children, className }: ContentProps) => {
  return <ContentStyles className={className}>{children}</ContentStyles>;
};
export default Content;
